import { Dialog, DialogContent, Grid } from "@mui/material";
import { Info, Error, CheckCircle } from "@mui/icons-material";

import DialogHeader from "./DialogHeader";

export default function LitcoInfoDialog(props) {
  const { open, onClose, title, subtitle, type } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader title={title} subtitle={subtitle} onClose={onClose} />

      <DialogContent>
        <Grid container alignItems="center" columnSpacing={2}>
          <Grid item>
            {(!type || type === "info") && <Info sx={{ color: "DodgerBlue", fontSize: 50 }} />}
            {type === "success" && <CheckCircle sx={{ color: "green", fontSize: 50 }} />}
            {type === "warning" && <Error sx={{ color: "orange", fontSize: 50 }} />}
            {type === "error" && <Error sx={{ color: "red", fontSize: 50 }} />}
          </Grid>
          <Grid item xs>
            {props.children}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
